export enum VasEntryPoint {
  PromoteListings = 'promote_listings',
  PromotedClosets = 'promoted_closets',
  ProfilePromotedClosets = 'profile_promoted_closets',
  PromotedClosetsStats = 'promoted_closets_stats',
  Bumps = 'bumps',
  NewMemberBumpOnboardingListingForm = 'new_member_bump_onboarding_listing_form',
}
